import React from 'react';
import { withRouter } from 'react-router-dom'

function DefaultFooter () {
    return (
        <div className="web-footer hide-on-print">
            <div className="container-fluid footer-content text-center">
                <p className="copyright-text mb-0">Copyright © Fortegra. All Rights Reserved.</p>
            </div>
        </div>
    )
}

export default withRouter(DefaultFooter);